import React from "react";
import { useDashboard } from "../../context/DashboardContext";
import { CheckCircle } from "lucide-react";

const ProfileHeader = () => {
  const { profile, metrics } = useDashboard();

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 bg-white p-6 rounded-lg shadow-sm">
      <div className="flex-shrink-0 w-20 h-20 rounded-full bg-purple-100 flex items-center justify-center">
        <span className="text-4xl font-medium text-purple-500">
          {profile.avatar}
        </span>
      </div>

      <div className="flex-grow">
        <div className="flex items-center gap-2">
          <h2 className="text-2xl font-semibold text-gray-800">
            {profile.name}
          </h2>
          {/* {profile.isVerified && (
            <div className="bg-green-200 text-green-600 px-2 py-0.5 rounded-full flex items-center text-xs font-medium">
              <CheckCircle className="h-3.5 w-3.5 mr-1" />
              VERIFIED
            </div>
          )} */}
        </div>
        <p className="text-gray-500 mt-1">{profile.tagline}</p>
        <p className="text-gray-400 text-sm mt-2">
          <span className="inline-flex items-center">{profile.contact}</span>
        </p>
      </div>

      <div className="mt-2 sm:mt-0 flex flex-col items-start sm:items-end">
        <div className="text-sm text-gray-500">Net realized P&L</div>
        <div className="flex items-center gap-2">
          <div className="text-gray-600 text-sm">
            {metrics.netProfitLoss.period.from} to{" "}
            {metrics.netProfitLoss.period.to}
          </div>
        </div>
        <div className="text-2xl font-semibold text-emerald-500 mt-1">
          {metrics.netProfitLoss.value}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
